import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Belgaumtodharwadcab() {



    const cardData = {




keyword: "Belgaum to Dharwad Cab",

headingDescription: "Belgaum Taxi Service offers safe and reliable Belgaum to Dharwad cab services for business travel, family visits, medical trips, educational purposes, airport transfers, and daily intercity transportation. Whether you need a one-way taxi or a round-trip cab from Belgaum to Dharwad, we provide comfortable travel options with experienced drivers and well-maintained vehicles. Choose from Sedan, Ertiga, SUV, Innova, Innova Crysta, and premium cab options based on your travel needs. Our services include doorstep pickup, flexible timings, transparent pricing, easy booking, and 24/7 customer assistance for a smooth journey. Belgaum Taxi Service provides convenient cab connectivity between Belgaum and Dharwad for students, professionals, families, and travelers looking for comfortable and affordable transportation.",

topPlaces: [
  {
    title: "Dharwad",
    description: "Dharwad is a prominent educational and cultural city in Karnataka, known for universities, institutions, music heritage, and peaceful surroundings. It is a popular destination for travelers from Belgaum."
  },
  {
    title: "Hubballi",
    description: "Hubballi is a major commercial and business hub near Dharwad, known for industries, markets, transport facilities, and corporate activities. Many travelers prefer cab services between Belgaum and Hubballi-Dharwad region."
  },
  {
    title: "Karnataka Institute of Medical Sciences (KIMS), Hubballi",
    description: "KIMS Hubballi attracts patients and visitors from different cities for healthcare services. Comfortable cabs provide convenient travel for medical visits."
  },
  {
    title: "Indian Institute of Technology Dharwad",
    description: "IIT Dharwad is a leading educational institution attracting students, faculty members, and visitors from across Karnataka, making it a frequent travel destination."
  },
  {
    title: "Bangalore",
    description: "Bangalore is Karnataka's major IT and business destination, known for corporate offices, technology parks, and commercial activities. Long-distance cabs provide comfortable connectivity from Dharwad and Belgaum."
  },
  {
    title: "Pune",
    description: "Pune is an important IT, education, and industrial city in Maharashtra. Travelers often choose private cabs for convenient interstate journeys."
  },
  {
    title: "Mumbai",
    description: "Mumbai is India's financial capital with major business areas, airports, and tourist attractions. Reliable cab services are preferred for comfortable long-distance travel."
  },
  {
    title: "Goa",
    description: "Goa is a popular leisure destination famous for beaches, resorts, churches, and sightseeing locations. Private cabs provide a comfortable travel option for holiday trips."
  },
  {
    title: "Hampi",
    description: "Hampi is a UNESCO World Heritage Site known for ancient temples, historical ruins, and unique landscapes, making it a popular tourist destination in Karnataka."
  },
  {
    title: "Gokarna",
    description: "Gokarna is a scenic coastal destination known for beaches, temples, and peaceful surroundings. It is a preferred weekend getaway for travelers looking for a relaxing trip."
  }
],




"services": [
  {
    "name": "Belgaum to Dharwad Cab",
    "description": "Book Belgaum to Dharwad Cab for safe, comfortable, and reliable intercity travel with professional chauffeurs and well-maintained AC vehicles. Choose from Sedan, Ertiga, Innova Crysta, and SUV cabs for business trips, family travel, sightseeing, airport transfers, and daily transportation with flexible one way and round trip options."
  },
  {
    "name": "Belgaum to Dharwad Taxi",
    "description": "Choose Belgaum to Dharwad Taxi for convenient and affordable travel between cities with experienced drivers, clean vehicles, transparent pricing, and doorstep pickup services. Enjoy a smooth journey with comfortable seating and reliable taxi solutions."
  },
  {
    "name": "Belgaum to Dharwad Cab Service",
    "description": "Our Belgaum to Dharwad Cab Service provides reliable transportation with professional drivers, comfortable AC cars, and affordable travel packages. Get hassle-free cab booking for personal trips, business travel, family journeys, and local transfers."
  },
  {
    "name": "Belgaum to Dharwad Taxi Service",
    "description": "Book Belgaum to Dharwad Taxi Service for safe and convenient city-to-city travel. Enjoy timely pickup, experienced chauffeurs, multiple vehicle choices, and smooth transportation for all types of travel requirements."
  },
  {
    "name": "Belgaum to Dharwad One Way Cab",
    "description": "Hire Belgaum to Dharwad One Way Cab for economical single-trip travel without return charges. Get fixed pricing, comfortable AC vehicles, professional drivers, and doorstep pickup facilities for a stress-free journey."
  },
  {
    "name": "Belgaum to Dharwad Cab Booking",
    "description": "Complete Belgaum to Dharwad Cab Booking online with easy reservations, quick confirmation, flexible pickup locations, and multiple cab options. Enjoy convenient taxi booking with transparent fares and reliable customer support."
  },
  {
    "name": "Belgaum to Dharwad Car Rental",
    "description": "Choose Belgaum to Dharwad Car Rental services for private chauffeur-driven travel. Select Sedan, SUV, Ertiga, or Innova Crysta vehicles according to your comfort, budget, and travel requirements."
  },
  {
    "name": "Belgaum to Dharwad Outstation Cab",
    "description": "Book Belgaum to Dharwad Outstation Cab for comfortable long-distance travel with experienced chauffeurs and well-maintained vehicles. Our outstation taxi services are suitable for family trips, business travel, and personal journeys."
  },
  {
    "name": "Belgaum to Dharwad Airport Cab",
    "description": "Reserve Belgaum to Dharwad Airport Cab for reliable airport pickup and drop services. Travel comfortably with professional drivers, spacious vehicles, and punctual airport transfer solutions."
  },
  {
    "name": "Belgaum to Dharwad Airport Taxi",
    "description": "Choose Belgaum to Dharwad Airport Taxi for smooth airport transportation with doorstep pickup, timely service, and comfortable AC cars. Ideal for passengers looking for safe and convenient airport travel."
  },
  {
    "name": "Belgaum to Dharwad Innova Crysta Cab",
    "description": "Book Belgaum to Dharwad Innova Crysta Cab for premium travel comfort with spacious interiors, luxury seating, and experienced chauffeurs. Perfect for family tours, corporate travel, airport transfers, and group journeys."
  },
  {
    "name": "Belgaum to Dharwad Ertiga Cab",
    "description": "Travel with Belgaum to Dharwad Ertiga Cab offering spacious 6 to 7 seater comfort, affordable fares, and reliable chauffeur services. Ideal for family trips, group travel, and outstation transportation."
  },
  {
    "name": "Belgaum to Dharwad Sedan Cab",
    "description": "Book Belgaum to Dharwad Sedan Cab for economical and comfortable travel with clean AC vehicles and professional drivers. Suitable for business trips, personal rides, airport transfers, and quick city travel."
  },
  {
    "name": "Belgaum to Dharwad Round Trip Cab",
    "description": "Hire Belgaum to Dharwad Round Trip Cab for flexible return journeys with affordable packages and experienced chauffeurs. Perfect for sightseeing, family outings, business visits, and planned travel."
  },
  {
    "name": "Belgaum to Dharwad Private Taxi",
    "description": "Choose Belgaum to Dharwad Private Taxi for exclusive chauffeur-driven travel with privacy, comfort, and flexible schedules. Get a dedicated vehicle for personal, family, and corporate transportation needs."
  },
  {
    "name": "Cheap Belgaum to Dharwad Cab",
    "description": "Book Cheap Belgaum to Dharwad Cab with budget-friendly fares, quality vehicles, and reliable service. Enjoy affordable travel solutions with safety, comfort, and professional driver assistance."
  },
  {
    "name": "Best Belgaum to Dharwad Cab Service",
    "description": "Choose the Best Belgaum to Dharwad Cab Service offering premium vehicles, skilled chauffeurs, competitive pricing, and dependable travel solutions for every journey requirement."
  },
  {
    "name": "Online Belgaum to Dharwad Cab Booking",
    "description": "Complete Online Belgaum to Dharwad Cab Booking with simple reservations, instant confirmation, transparent pricing, and multiple vehicle options. Enjoy hassle-free taxi booking anytime."
  },
  {
    "name": "Belgaum to Dharwad Taxi Fare",
    "description": "Check Belgaum to Dharwad Taxi Fare with affordable packages and flexible vehicle options. Select Sedan, Ertiga, Innova Crysta, or SUV cabs based on your travel needs and budget."
  },
  {
    "name": "24/7 Belgaum to Dharwad Cab Service",
    "description": "Get 24/7 Belgaum to Dharwad Cab Service with round-the-clock availability, experienced drivers, clean AC vehicles, and reliable transportation support for urgent and planned journeys."
  },
  {
    "name": "Dharwad Tour Package in Karnataka",
    "description": "Explore Dharwad Tour Package in Karnataka with comfortable cab services, experienced drivers, and customized sightseeing options. Travel conveniently to popular attractions, nearby destinations, and cultural places with family and friends."
  },
  {
    "name": "Belgaum to Dharwad Innova Cabs Service",
    "description": "Book Belgaum to Dharwad Innova Cabs Service for spacious and premium travel with Toyota Innova Crysta vehicles, professional chauffeurs, and comfortable seating. Ideal for family trips, corporate travel, and long-distance journeys."
  }
],
"tableData": [
  ["Belgaum to Dharwad Cab", "Belgaum to Dharwad Taxi"],
  ["Belgaum to Dharwad Cab Service", "Belgaum to Dharwad Taxi Service"],
  ["Belgaum to Dharwad One Way Cab", "Belgaum to Dharwad Cab Booking"],
  ["Belgaum to Dharwad Car Rental", "Belgaum to Dharwad Outstation Cab"],
  ["Belgaum to Dharwad Airport Cab", "Belgaum to Dharwad Airport Taxi"],
  ["Belgaum to Dharwad Innova Crysta Cab", "Belgaum to Dharwad Ertiga Cab"],
  ["Belgaum to Dharwad Sedan Cab", "Belgaum to Dharwad Round Trip Cab"],
  ["Belgaum to Dharwad Private Taxi", "Cheap Belgaum to Dharwad Cab"],
  ["Best Belgaum to Dharwad Cab Service", "Online Belgaum to Dharwad Cab Booking"],
  ["Belgaum to Dharwad Taxi Fare", "24/7 Belgaum to Dharwad Cab Service"],
  ["Dharwad Tour Package in Karnataka", "Belgaum to Dharwad Innova Cabs Service"]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Belgaum to Dharwad Cab Service",
    WhyChoosedescription: "Belgaum Taxi Service provides comfortable Belgaum to Dharwad cab services with experienced drivers, well-maintained vehicles, and convenient travel solutions for business and personal journeys."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Belgaum",
    WhyChoosedescription: "Get hassle-free pickup from Belgaum Airport, Railway Station, hotels, homes, offices, and nearby locations with direct drop anywhere in Dharwad."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options Available",
    WhyChoosedescription: "Choose from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, SUVs, and premium cars according to your comfort and travel requirements."
  },
  {
    WhyChooseheading: "Professional Drivers for Safe Travel",
    WhyChoosedescription: "Our skilled chauffeurs ensure safe driving, timely service, and a smooth journey with excellent knowledge of the Belgaum to Dharwad route."
  },
  {
    WhyChooseheading: "One Way & Round Trip Cab Booking",
    WhyChoosedescription: "Book a one-way taxi or select a round-trip cab package with flexible schedules and comfortable travel options."
  },
  {
    WhyChooseheading: "Affordable Belgaum to Dharwad Taxi Fare",
    WhyChoosedescription: "Enjoy competitive pricing with transparent fares, customized packages, and no hidden charges for your cab journey."
  },
  {
    WhyChooseheading: "Suitable for Business & Personal Trips",
    WhyChoosedescription: "Our Belgaum to Dharwad cabs are ideal for office visits, airport transfers, family travel, medical trips, and local transportation."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Support",
    WhyChoosedescription: "Book your Belgaum to Dharwad cab anytime with quick confirmation and dedicated customer assistance."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Belgaum to Dharwad Cab Service?",
    answer: "Yes, we offer reliable Belgaum to Dharwad cab services with comfortable vehicles and professional drivers."
  },
  {
    question: "Can I book a one-way cab from Belgaum to Dharwad?",
    answer: "Yes, one-way taxi services are available with pickup from any location in Belgaum."
  },
  {
    question: "Which vehicles are available for Belgaum to Dharwad travel?",
    answer: "We provide Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, SUVs, and other comfortable vehicles."
  },
  {
    question: "Do you provide pickup from Belgaum Airport and Railway Station?",
    answer: "Yes, we provide convenient pickup and drop services from Belgaum Airport, Railway Station, hotels, and residential areas."
  },
  {
    question: "Is Belgaum to Dharwad cab service available 24/7?",
    answer: "Yes, our cab services are available 24 hours a day for your preferred travel schedule."
  },
  {
    question: "Can I book a return cab from Dharwad to Belgaum?",
    answer: "Yes, return and round-trip taxi services are available with flexible travel timings."
  },
  {
    question: "Are toll and parking charges included in the taxi fare?",
    answer: "Toll charges, parking fees, state taxes, and other applicable charges are generally billed separately unless included in the confirmed quotation."
  },
  {
    question: "Is this cab service suitable for family travel?",
    answer: "Yes, our Belgaum to Dharwad taxi service provides comfortable and safe travel options for families, groups, and personal trips."
  },
  {
    question: "Can I book a private taxi from Belgaum to Dharwad?",
    answer: "Yes, we provide private cab services with dedicated vehicles and professional drivers for a comfortable journey."
  },
  {
    question: "How can I book a Belgaum to Dharwad Cab?",
    answer: "Share your pickup location, destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Vinay Kulkarni",
    feedback: "The Belgaum to Dharwad cab service was comfortable and reliable. The driver arrived on time, the vehicle was clean, and the journey was smooth.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Shweta Patil",
    feedback: "We had a great experience booking a cab from Belgaum to Dharwad. The service was affordable, professional, and completely hassle-free.",
    rating: 5
  }
];





    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Belgaum to Dharwad Cab",
  "image": "https://www.belgaumtaxiservice.com/assets/images/belgaum-to-dharwad-cab.webp",
  "description":
    "Book Belgaum to Dharwad Cab with Belgaum Taxi Service for safe, comfortable, and affordable taxi services. We provide one-way and round-trip cabs from Belgaum to Dharwad with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for local travel, business trips, and outstation journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/belgaum-to-dharwad-cab"
  }
};





    return (
        <div>
<Helmet>
  <title>Belgaum to Dharwad Cab | Taxi Service | +91 8722158435</title>

  <meta
    name="description"
    content="Book Belgaum to Dharwad Cab with Belgaum Taxi Service for reliable one-way and round-trip taxi services. Get affordable cabs from Belgaum to Dharwad with Sedan, Ertiga, SUV, Innova, and Innova Crysta for local travel, business trips, and outstation journeys available 24x7."
  />

  <meta
    name="keywords"
    content="Belgaum to Dharwad Cab, belgaum to dharwad taxi fare, belgaum to dharwad taxi price, belgaum to dharwad cab service, belgaum to dharwad cab package, Belgaum to Dharwad Taxi, Belgaum to Dharwad Cab Service, Belgaum to Dharwad One Way Cab, Belgaum to Dharwad Outstation Taxi, Belgaum to Dharwad Car Rental"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>








            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/22.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Belgaumtodharwadcab;